var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8776 10.2525C3.70135 10.08 3.6001 9.84748 3.6001 9.59998C3.6001 9.35248 3.70135 9.11998 3.8776 8.94748L10.4776 2.64748C10.8376 2.30248 11.4076 2.31748 11.7488 2.67748C12.0901 3.03748 12.0788 3.60748 11.7188 3.94873L6.74635 8.69998H19.5001C19.9988 8.69998 20.4001 9.10123 20.4001 9.59998C20.4001 10.0987 19.9988 10.5 19.5001 10.5H6.74635L11.7226 15.2475C12.0826 15.5925 12.0938 16.1587 11.7526 16.5187C11.4113 16.8787 10.8413 16.89 10.4813 16.5487L3.88135 10.2487L3.8776 10.2525Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftWhite);
export default __webpack_public_path__ + "static/media/arrow-left-white.4ced5f78060fb02de8b34d77207ea83f.svg";
export { ForwardRef as ReactComponent };